import type { MouseEvent } from 'react';

// Alt-click downloads the target in some browsers, so it counts as modified too.
export function isModifiedClick(event: MouseEvent): boolean {
    return event.ctrlKey || event.metaKey || event.shiftKey || event.altKey || event.button === 1;
}
